export default {
  POST_WEB_TO_SALESFORCE_REQUESTED: 'POST_WEB_TO_SALESFORCE_REQUESTED',
  POST_WEB_TO_SALESFORCE_SUCCEEDED: 'POST_WEB_TO_SALESFORCE_SUCCEEDED',
  POST_WEB_TO_SALESFORCE_FAILED: 'POST_WEB_TO_SALESFORCE_FAILED',
};
